import React from 'react';
import {
  Button,
  Divider,
  Form,
  Icon,
  Grid,
  Accordion,
} from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { DatePickerField, CheckboxField } from 'Common/SemanticWrapper';
import { DATE_FORMAT_FOR_UI, printOptions } from 'Common/Constants';
import { TransactionSummaryEnum } from 'Common/FieldEnum';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { CREATE_TRANSACTION_FORM_NAME } from 'Common/FormEnum';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { DatePickerCustomButton } from 'Components';
import { getDates } from 'Common/FormHelper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import ReactTable from 'Common/ReactTableWrapper';

const CreateTransactionFormComponent = props => {
  const {
    activeIndexes = [],
    handleCollapsePanelClick,
    onChangeOfFromDT,
    fromDateMax,
    onChangeOfToDT,
    toDateMin,
    fetchExistingTranSummaryPreviewLoading,
    previewTransaction,
    getPhysicals,
    closePeriodLoading,
    closePeriod,
    physicalForTranSummaryList,
    fetchPhysicalForTranSummaryListLoading,
    columns,
    showDialog,
    onSubmitClick,
    showWarningDialog,
    fetchOpenTransactionWarningMsg,
    openTransactionPrint,
    isPreviewClicked,
  } = props;
  return (
    <Form>
      <Accordion fluid styled>
        <Accordion.Title
          active={activeIndexes.indexOf(0) !== -1}
          index={0}
          onClick={handleCollapsePanelClick}
        >
          <Icon name="dropdown" />
          <span className="text-orange">Filter By</span>
        </Accordion.Title>
        <Accordion.Content active={activeIndexes.indexOf(0) !== -1}>
          <Grid className="grid-spacing">
            <Grid.Row columns={4}>
              <Grid.Column>
                <Field
                  component={DatePickerField}
                  customInput={<DatePickerCustomButton isDisabled={true} />}
                  label={'Begin Date:'}
                  dateFormat={DATE_FORMAT_FOR_UI}
                  name={TransactionSummaryEnum.BeginDT}
                  onChange={onChangeOfFromDT}
                  maxDate={fromDateMax}
                  type={'text'}
                  dropdownMode="select"
                  includeDates={getDates(true)}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  component={DatePickerField}
                  customInput={<DatePickerCustomButton />}
                  label={'End Date:'}
                  dateFormat={DATE_FORMAT_FOR_UI}
                  name={TransactionSummaryEnum.EndDT}
                  type={'text'}
                  onChange={onChangeOfToDT}
                  minDate={toDateMin}
                  includeDates={getDates(true)}
                  dropdownMode="select"
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Accordion.Content>
        <Accordion.Title
          active={activeIndexes.indexOf(1) !== -1}
          index={1}
          onClick={handleCollapsePanelClick}
        >
          <Icon name="dropdown" />
          <span className="text-orange">Sort By</span>
        </Accordion.Title>
        <Accordion.Content active={activeIndexes.indexOf(1) !== -1}>
          <Grid>
            <Grid.Row className={'pt5'}>
              <Grid.Column width={5} verticalAlign={'bottom'}>
                <ReduxFormButtonGroup
                  options={printOptions}
                  formName={CREATE_TRANSACTION_FORM_NAME}
                  fieldName={TransactionSummaryEnum.PrintOptions}
                  type={'button'}
                />
              </Grid.Column>
              <Grid.Column width={4} verticalAlign={'top'} className={'pt10'}>
                <Field
                  component={CheckboxField}
                  label={'Show Summary details'}
                  name={TransactionSummaryEnum.ShowDetails}
                  toggle
                />
              </Grid.Column>
              <Grid.Column width={7}>
                <Button
                  loading={fetchPhysicalForTranSummaryListLoading}
                  content="Get Physicals"
                  type={'button'}
                  style={{ marginLeft: 10 }}
                  onClick={getPhysicals}
                />
                <Button
                  loading={fetchExistingTranSummaryPreviewLoading}
                  content="Preview"
                  type={'button'}
                  style={{ marginLeft: 10 }}
                  onClick={previewTransaction}
                />
                <Button
                  loading={closePeriodLoading}
                  content="Close Period"
                  type={'button'}
                  style={{ marginLeft: 10 }}
                  onClick={closePeriod}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Accordion.Content>
      </Accordion>
      <Divider horizontal />
      <Grid>
        <Grid.Row columns={1} className={'remove-spacing'}>
          <Grid.Column>
            <ReactTable
              defaultPageSize={20}
              showPageSizeOptions={true}
              minRows={0}
              data={physicalForTranSummaryList}
              noDatatext={'No rows found'}
              resizable={false}
              className="-striped -highlight modalGrid"
              columns={columns}
              loading={fetchPhysicalForTranSummaryListLoading}
              saveState={{
                tableName: TableNamesEnum.CREATE_TRANSACTION_SUMMARY_TABLE,
              }}
              menu={false}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <YesNoDialog
        showDialog={showDialog || showWarningDialog}
        title={
          showWarningDialog
            ? fetchOpenTransactionWarningMsg[TransactionSummaryEnum.Title]
            : 'Inventory'
        }
        question={
          showWarningDialog
            ? fetchOpenTransactionWarningMsg.Data[
                TransactionSummaryEnum.WarningMessage
              ]
            : isPreviewClicked
            ? 'Would you like to continue the Transaction Summary preview?'
            : 'Are you sure you want to close this transaction period?'
        }
        yesCallback={() =>
          showWarningDialog ? openTransactionPrint(true) : onSubmitClick(true)
        }
        noCallback={() =>
          showWarningDialog ? openTransactionPrint(false) : onSubmitClick(false)
        }
      />
    </Form>
  );
};

CreateTransactionFormComponent.propTypes = {
  activeIndexes: PropTypes.array,
  handleCollapsePanelClick: PropTypes.func,
  onChangeOfFromDT: PropTypes.func,
  fromDateMax: PropTypes.object,
  onChangeOfToDT: PropTypes.func,
  toDateMin: PropTypes.object,
  fetchExistingTranSummaryPreviewLoading: PropTypes.bool,
  previewTransaction: PropTypes.func,
  getPhysicals: PropTypes.func,
  closePeriodLoading: PropTypes.bool,
  closePeriod: PropTypes.func,
  physicalForTranSummaryList: PropTypes.array.isRequired,
  fetchPhysicalForTranSummaryListLoading: PropTypes.bool,
  columns: PropTypes.array.isRequired,
  showDialog: PropTypes.bool,
  onSubmitClick: PropTypes.func,
  isPreviewClicked: PropTypes.bool,
};

export default CreateTransactionFormComponent;



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transactionSummary/components/createTransactionSummary/CreateTransactionFormComponent.js